var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"card-button"},[_c('i',{staticClass:"fa fa-copy card-icon"})])
}]

export { render, staticRenderFns }